/* eslint-disable max-lines */
import { clear_token, get_token, get_user_details , set_user_details } from "@/router";
import { client_domain } from "@/main.js";
import Swal from 'sweetalert2';
import MenuSideBar from '@/components/MenuSidebar/MenuSidebar.vue'
import NotificationDropdown from '@/components/Notifications/Notification.vue'
import HomeSidebar from '@/components/HomeSidebar/HomeSidebar.vue'
import StickyNav from "@/components/BottomNavbar/StickyNavbar.vue";
const GOOGLE_MAP_API_KEY = process.env.VUE_APP_GOOGLE_MAP_API_KEY;
import Cart from '@/components/cart/CartView.vue';
import { view_profile_product } from "@/views/Marketplace/marketplace_helpers";
import {
  view_profile as view_profile_helper,
} from "@/views/home/home_helper.js";
import {
  append_active_organization_id,
  first_persistent_logo_url,
  get_active_organization_id,
  get_active_profile_id,
  get_organization_branding,
  get_organization_profile_branding,
  is_organization_admin_role,
  parse_json_or_null,
  save_organization_branding,
} from "@/utils/organization_profile";
import {
  load_company_profile_google_map,
  profile_matches_type,
} from "./home_nav_helpers";

function get_branding_profile(current_profile, active_base_profile) {
  return current_profile || active_base_profile || {};
}

function get_branding_company(profile = {}) {
  return profile.company || profile;
}

export default {
  emits: [
    'active_profile',
    'active-profile-loaded',
    'activeProfileLoaded',
    'business_profile_created',
    'location_selected',
    'new_report',
    'new_temp_post',
    'notification-count-updated',
    'notificationCountUpdated',
    'profile_updated',
    'questions_fetched',
    'toggleMenu',
  ],

  components: {
    NotificationDropdown,
    HomeSidebar,
    MenuSideBar,
    Cart,
    StickyNav
  },
  inject: ['client_features'],
  computed: {
    navbar_logo() {
      const organization_logo = first_persistent_logo_url(this.organization_logo);

      if (this.is_enabled_feature(this.client_features?.show_organisation) && organization_logo) {
        return organization_logo;
      }

      return this.$clientLogo;
    },
    workspace_community_name() {
      return [
        localStorage.getItem('company_name'),
      ].find((name) => String(name || '').trim()) || '';
    },
    is_home_page() {
      return this.$route.name === 'home'; // Assuming your home page route is named 'home'
    },
    is_events_page() {
      return this.$route.name === 'view_events';
    },
    is_home_filter_or_view_portal() {
      return this.$route.name === 'home_filter' || this.$route.name === 'view_portal'|| this.$route.name === 'view_events';
    },
    first_name_initial() {
      return this.user_details.first_name.charAt(0);
    },
    visible_base_profiles() {
      const profiles = this.base_profiles || [];
      const active_personal_profile = profiles.find((profile) => this.matches_profile_type(profile, 'personal'));

      // Filter out duplicate personal profiles
      const unique_profiles = profiles.filter((profile, index, self) => {
        return (
          !this.matches_profile_type(profile, 'personal') || // Keep non-personal profiles
          index === self.findIndex((item) => this.matches_profile_type(item, 'personal') && item.id === profile.id) // Keep only the first unique personal profile
        );
      });

      let result = unique_profiles.slice();

      result = result.filter((profile, index, self) => {
        return (
          !this.matches_profile_type(profile, 'personal') || // Keep non-personal profiles
          (active_personal_profile ? profile.id === active_personal_profile.id : index === self.findIndex((item) => this.matches_profile_type(item, 'personal'))) // Keep only the active personal profile or the first one
        );
      });

      return this.show_all ? result : result.slice(0, 3);
    },

    is_organization_only_session() {
      return is_organization_admin_role(this.user_details);
    },
    can_create_business_profile() {
      return this.is_enabled_feature(this.client_features?.show_business_profile)
        && !is_organization_admin_role(this.user_details);
    },
    can_show_business_profiles() {
      return this.is_enabled_feature(this.client_features?.show_business_profile)
        && !is_organization_admin_role(this.user_details);
    },
    can_switch_profile() {
      return !is_organization_admin_role(this.user_details);
    },

    active_base_profile() {
      return this.is_organization_only_session
        ? this.get_organization_base_profile()
        : this.get_active_personal_base_profile();
    },
    visible_profiles() {
      if (!this.filtered_profiles?.profiles) {
        return [];
      }

      return this.expanded_section === 'people'
        ? this.filtered_profiles.profiles
        : this.filtered_profiles.profiles.slice(0, 3);
    },
    has_any_results() {
      const lists = [
        this.filtered_recent,
        this.filtered_profiles?.profiles,
        this.filtered_profiles?.companies,
        this.filtered_profiles?.portals,
        this.filtered_profiles?.reports,
        this.filtered_profiles?.products
      ]

      return lists.some(list => Array.isArray(list) && list.length > 0)
    },
  visible_companies() {
    if (!this.filtered_profiles.companies) return [];
    return this.expanded_section === 'companies'
      ? this.filtered_profiles.companies
      : this.filtered_profiles.companies.slice(0, 3);
  },
  visible_portals() {
    if (!this.filtered_profiles.portals) return [];
    return this.expanded_section === 'portals'
      ? this.filtered_profiles.portals
      : this.filtered_profiles.portals.slice(0, 3);
  },
  visible_reports() {
    if (!this.filtered_profiles.reports) return [];
    return this.expanded_section === 'reports'
      ? this.filtered_profiles.reports
      : this.filtered_profiles.reports.slice(0, 3);
  },
  visible_products() {
    if (!this.filtered_profiles.products) return [];
    return this.expanded_section === 'products'
      ? this.filtered_profiles.products
      : this.filtered_profiles.products.slice(0, 3);
  },

  },

  mounted() {
    this.token_exists = get_token();
    this.user_details = get_user_details();
    this.load_google_map_event();
    this.user_id = this.get_user_id();
    this.fetch_type_of_organization();
    this.fetch_type_of_profile();
    this.get_all_profile();
    this.fetch_profiles();
    this.toggle_show_all();
    this.get_active_profile();
    this.load_active_profile_branding();
    this.get_search_history();
    document.addEventListener("click", this.handle_outside_click);
    window.addEventListener("organization-branding-updated", this.handle_organization_branding_updated);
    window.addEventListener("organization-profile-updated", this.handle_organization_profile_updated);

    if(client_domain.includes('cbo') ||client_domain.includes('tdm') || client_domain.includes('chamber') ||
    client_domain.includes('demo') ||client_domain.includes('engagenet') || client_domain.includes('dwypd') ||
    client_domain.includes('bosa') || client_domain.includes('apex') || client_domain.includes('vettedsa')) {
      this.visible_domain = true;
      $('#company_profile_modal').on('hidden.bs.modal', () => {
        this.update_first_time_login_status();
      });
    }
    $('#company_profile_modal').on('shown.bs.modal', () => {
      this.load_google_map_event();
    });
    if (client_domain.includes('vettedsa') || client_domain.includes('engagenet')) {
      this.marketplace_domain = true;
    }
    if (client_domain.includes('vettedsa')) {
      this.vettedsa_domain = true;
    }

    if(client_domain.includes('workbook')) {
      this.workbook_domain = true;
    }
    if(client_domain.includes('chiefluthuli')) {
      this.school_domain = true;
    }
    if(client_domain.includes('soulcity') || client_domain.includes('nsp') || client_domain.includes('dwypd') || client_domain.includes('aicreads') ) {
      this.soulcity_domain = true;
    }
    if(client_domain.includes('cbo')) {
      this.cbo_domain = true;
    }

    this.$nextTick(() => {
      const home_nav_offcanvas = document.getElementById('offcanvasExample');
      if (!home_nav_offcanvas) return;

      this.home_nav_offcanvas_show_handler = () => {
        this.$el?.classList?.add('home-nav-offcanvas-active');
      };
      this.home_nav_offcanvas_hidden_handler = () => {
        this.$el?.classList?.remove('home-nav-offcanvas-active');
      };

      home_nav_offcanvas.addEventListener('show.bs.offcanvas', this.home_nav_offcanvas_show_handler);
      home_nav_offcanvas.addEventListener('hidden.bs.offcanvas', this.home_nav_offcanvas_hidden_handler);
    });

  },
  beforeUnmount() {
    document.removeEventListener("click", this.handle_outside_click);
    window.removeEventListener("organization-branding-updated", this.handle_organization_branding_updated);
    window.removeEventListener("organization-profile-updated", this.handle_organization_profile_updated);
    const home_nav_offcanvas = document.getElementById('offcanvasExample');
    if (home_nav_offcanvas) {
      home_nav_offcanvas.removeEventListener('show.bs.offcanvas', this.home_nav_offcanvas_show_handler);
      home_nav_offcanvas.removeEventListener('hidden.bs.offcanvas', this.home_nav_offcanvas_hidden_handler);
    }
  },
  watch: {
    active_base_profile: {
      immediate: true,
      handler(new_profile) {
        this.$emit('active_profile', new_profile);
      }
    }
    
  },
  data() {
    return ({
       expanded_section: null,
      search_history: [],
      filtered_recent: [],
      token_exists: false,
      user_id:null,
      cbo_domain: false,
      visible_domain: false,
      user_details: {
        "user_role":'',
        "first_name":'',
        "last_name":'',
      },
      show_menu: false,
      show_cart:false,
      show_icons: false,
      show_search: false,
      users: [], // Add profiles data property
      filtered_profiles: [],
      search_query: '',
      is_sidebar_open: false,
      is_event_sidebar_open: false,
      company_name: '',
      type_of_organization: [],
      description: '',
      email: '',
      tell_number: '',
      location: '',
      address_list: {
        street_address: '',
        suburb: '',
        town: '',
        province: '',
        postal_code: '',
        country: '',
      },
      organization_types: [],
      errors: {},
      is_loading: false,
      profile_switch_loading: false,
      selected_type_of_organization: '',
      type_of_profile: [],
      selected_profile: null,
      base_profiles: [],
      current_profile: null,
      display_letter: '',
      display_name: '',
      is_business_profile: false,
      company_data: null,
      show_all: false,
      profile_questions: [],
      workbook_domain: false,
      search_timeout: null,
      is_edit_mode:false,
      base_profile_id: null,
      longitude:null,
      latitude:null,
      company_address_autocomplete: null,
      company_address_input: null,
      receive_emails: true,
      receive_notifications: true,
      show_notification_settings: false,
      soulcity_domain: false,
      school_domain: false,
      marketplace_domain: false,
      vettedsa_domain: false,
      organization_logo: localStorage.getItem('organization_logo') || '',
      saved_branding: null,
      organization_branding_loading: false,
    });
  },

  watch: {
    search_query() {
      this.filter_profiles();
    },
    active_base_profile: {
      immediate: true,
      handler(new_profile) {
        this.$emit('active_profile', new_profile);
        this.load_active_profile_branding();
      }
    }
  },
  methods: {
    get_organization_base_profile() {
      const active_organization_id = get_active_organization_id();
      const active_profile = this.base_profiles.find((profile) =>
        this.matches_active_organization_profile(profile, active_organization_id)
      );
      return active_profile || this.get_first_business_base_profile();
    },
    get_first_business_base_profile() {
      return this.base_profiles.find((profile) => this.matches_profile_type(profile, 'business')) || null;
    },
    get_active_personal_base_profile() {
      return this.base_profiles.find(profile => profile.is_active) || null;
    },
    is_enabled_feature(value) {
      return value === true || value === 'true' || value === 1 || value === '1';
    },
    get_client_domain_label() {
      return String(client_domain || '')
        .split('.')[0]
        .replace(/[-_]+/g, ' ')
        .trim();
    },
    handle_navbar_logo_error(event) {
      if (event?.target?.src === this.$clientLogo) return;

      if (event?.target) {
        event.target.src = this.$clientLogo;
      }
    },
    matches_active_organization_profile(profile, active_organization_id) {
      if (!active_organization_id) return false;

      const profile_organization_id = this.get_profile_organization_id(profile);
      return this.matches_profile_type(profile, 'business')
        && this.matches_organization_id(profile_organization_id, active_organization_id);
    },
    get_profile_organization_id(profile) {
      return [
        profile?.company?.id,
        profile?.company_id,
      ].find(Boolean) || '';
    },
    matches_organization_id(profile_organization_id, active_organization_id) {
      return String(profile_organization_id) === String(active_organization_id);
    },
    get_active_profile_id_for_branding() {
      return get_active_profile_id(this.current_profile || {}) ||
        get_active_profile_id(this.active_base_profile || {});
    },
    get_branding_storage_key() {
      return `organization_branding_${this.get_active_profile_id_for_branding() || this.user_id || 'current'}`;
    },
    get_branding_context() {
      return {
        organization_id: this.current_profile?.company?.id
          || this.user_details?.organization_id
          || get_active_organization_id(),
        profile_id: this.get_active_profile_id_for_branding(),
        user_id: this.user_id,
      };
    },
    get_context_branding_key(value) {
      return value ? `organization_branding_${value}` : null;
    },
    get_saved_branding() {
      return get_organization_branding(this.get_branding_context())
        || this.get_profile_branding()
        || parse_json_or_null(localStorage.getItem(this.get_branding_storage_key()));
    
    },
    get_profile_branding() {
      const profile = get_branding_profile(this.current_profile, this.active_base_profile);
      return get_organization_profile_branding(
        get_branding_company(profile),
        this.user_details || {}
      );
    },
    clear_branding_overrides() {
      const root = document.documentElement;
      [
        "--primary-color",
        "--secondary-color",
        "--tertiary-color",
        "--accent-color",
      ].forEach((property) => {
        root.style.removeProperty(property);
      });
    },
    apply_branding_to_navbar(branding) {
      this.saved_branding = branding || null;

      if (!branding) {
        this.clear_navbar_branding();
        return;
      }

      this.apply_navbar_logo(first_persistent_logo_url(branding?.logo_preview));
      this.apply_branding_colors(branding);
    },
    clear_navbar_branding() {
      this.organization_logo = '';
      localStorage.removeItem('organization_logo');
      this.clear_branding_overrides();
    },
    apply_navbar_logo(logo) {
      this.organization_logo = logo || '';

      if (logo) {
        localStorage.setItem('organization_logo', logo);
      } else {
        localStorage.removeItem('organization_logo');
      }
    },
    apply_branding_colors(branding) {
      const root = document.documentElement;
      this.apply_primary_branding_color(root, branding.primary_color);
      this.apply_branding_color(root, "--secondary-color", branding.secondary_color);
      this.apply_branding_color(root, "--tertiary-color", branding.tertiary_color);
    },
    apply_primary_branding_color(root, color) {
      if (!color) return;
      root.style.setProperty("--primary-color", color);
      root.style.setProperty("--accent-color", color);
    },
    apply_branding_color(root, property, color) {
      if (!color) return;
      root.style.setProperty(property, color);
    },
    load_active_profile_branding() {
      this.fetch_organization_branding();
      const branding = this.get_saved_branding();
      this.apply_branding_to_navbar(branding);
    },
    get_company_profile_data(response) {
      return response?.data?.company_data;
    },
    get_organization_branding_id() {
      return get_active_organization_id()
        || null;
    },
    fetch_organization_branding() {
      const organization_id = this.get_organization_branding_id();

      if (!organization_id || !get_token() || this.organization_branding_loading) return;

      this.organization_branding_loading = true;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_company_profile/`,
        type: "POST",
        headers: {
          Authorization: `Token ${get_token()}`,
          "Content-Type": "application/json",
        },
        data: JSON.stringify({ organization_id }),
        success: (response) => {
          const company = this.get_company_profile_data(response);
          const branding = get_organization_profile_branding(company || {}, this.user_details || {});

          if (!branding) return;

          save_organization_branding(branding, {
            organization_id,
            profile_id: branding.profile_id,
            user_id: this.user_id,
          });
          this.apply_branding_to_navbar(branding);
        },
        complete: () => {
          this.organization_branding_loading = false;
        },
      });
    },
    handle_organization_branding_updated(event) {
      if (event?.detail?.reset) {
        this.apply_branding_to_navbar(null);
        return;
      }

      if (event?.detail) {
        this.apply_branding_to_navbar(event.detail);
        return;
      }

      this.apply_branding_to_navbar(null);
    },
    get_empty_company_address() {
      return ({
        street_address: '',
        suburb: '',
        town: '',
        province: '',
        postal_code: '',
        country: '',
      });

    },

    handle_organization_profile_updated() {
      this.get_active_profile();
      this.fetch_profiles();
    },
    fetchProfiles() {
      return this.fetch_profiles();
    },
    close_home_nav_offcanvas() {
      $('#offcanvasExample').offcanvas('hide');
    },
    open_profile_switcher() {
      if (!this.can_switch_profile) return;

      const offcanvas_el = document.getElementById('offcanvasExample');
      if (!offcanvas_el) return;

      if (window.bootstrap?.Offcanvas) {
        window.bootstrap.Offcanvas.getOrCreateInstance(offcanvas_el).show();
        return;
      }

      $('#offcanvasExample').offcanvas('show');
    },
    open_notification_offcanvas() {
      this.$refs.notificationDropdown?.open_offcanvas?.();
    },
    update_notification_count(count) {
      this.$emit('notification-count-updated', count);
    },

   open_manage_business() {
  $('#offcanvasExample').offcanvas('hide')

  setTimeout(() => {
    $('#manageBusinessModal').modal('show')
  }, 300)
},

open_company_profile_modal() {
  if (!this.can_create_business_profile) return;
   $('#offcanvasExample').offcanvas('hide')

  setTimeout(() => {
    $('#company_profile_modal').modal('show')
  }, 300)
},
    toggle_menu(e){
      $('.dropdown-menu.show').each(function () {
        $(this).removeClass('show');
        $(this).closest('.dropdown').find('[data-bs-toggle="dropdown"]').attr('aria-expanded', 'false');
      });
      this.show_menu = !this.show_menu;
      e.stopPropagation();
    },
    handle_outside_click(e) {
      if (!this.$el.contains(e.target)) {
        this.show_menu = false;
      }
    },
    open_manage_business_modal() {
      $('#manageBusinessModal').modal('show');
    },
    delete_company_profile(profile_id) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'This will permanently delete the company profile.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, delete it!',
        position: 'bottom-end',
        toast: true
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/delete_user_company_profile/`,
            type: 'DELETE',
            headers: {
              Authorization: `Token ${get_token()}`,
              'Content-Type': 'application/json'
            },
            data: JSON.stringify({profile_id: profile_id}),
            success: (response) => {
              if (response.status === 'success') {
                Swal.fire({
                  title: 'Deleted!',
                  text: response.message,
                  icon: 'success',
                  timer: 1500,
                  showConfirmButton: false,
                  position: 'bottom-end',
                  toast: true
                });

                // Find the deleted profile object
                const deleted_profile = this.base_profiles.find(p => p.id === profile_id);

                // Remove the deleted profile from the source list
                this.base_profiles = this.base_profiles.filter(p => p.id !== profile_id);

                // Close modal
                $('#manageBusinessModal').modal('hide');

                // If deleted profile was active and business type, switch to personal profile
                if (deleted_profile?.is_active && this.matches_profile_type(deleted_profile, 'business')) {
                  // Find active personal profile
                  const personal_profile = this.base_profiles.find((profile) => this.matches_profile_type(profile, 'personal'));

                  if (personal_profile) {
                    // Switch to personal profile via your existing switch method
                    this.switch_profile(personal_profile.id, false); // pass false to avoid loading indicator if you want
                  }
                }
              }
            },
            error: (err) => {
              Swal.fire({
                title: 'Error!',
                text: err.responseJSON?.message || 'Something went wrong',
                icon: 'error',
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000,
                toast: true
              });
            }
          });
        }
      });
    },


    open_edit_profile(business) {
    this.is_edit_mode = true;

    this.company_name = business.company_name;
    this.selected_type_of_organization = business.type_of_organization;
    this.description = business.description || "";
    this.email = business.email || "";
    this.tell_number = business.tell_number || "";
    this.location = business.location || "";
    this.address_list = {
      street_address: business.street_address || "",
      suburb: business.suburb || business.local_area || business.address?.suburb || "",
      town: business.town || business.city || business.address?.city || "",
      province: business.province || business.address?.province || "",
      postal_code: business.postal_code || business.code || business.address?.postal_code || "",
      country: business.country || business.address?.country || "",
    };
    this.latitude = business.latitude || business.address?.latitude || null;
    this.longitude = business.longitude || business.address?.longitude || null;
    this.base_profile_id= business.base_profile.id;
    $('#company_profile_modal').modal('show');
    this.$nextTick(() => {
      if (this.$refs.quill_company_editor_ref) {
        const quill_editor = this.$refs.quill_company_editor_ref.getQuill();
        if (quill_editor) {
          quill_editor.clipboard.dangerouslyPasteHTML(this.description);
        }
      }
    });
  },
  load_google_map_event() {
      load_company_profile_google_map(this, GOOGLE_MAP_API_KEY);
    },
    google_places_is_ready() {
      return !!window.google?.maps?.places;
    },
    initialize_company_profile_map_on_next_tick() {
      this.$nextTick(() => this.initialize_map());
    },
    register_company_profile_map_callback() {
      window.initCompanyProfileMap = () => {
        this.initialize_company_profile_map_on_next_tick();
      };
    },
    create_google_maps_script() {
      const script = document.createElement('script');
      script.id = 'googleMapsScript';
      script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAP_API_KEY}&libraries=places&callback=initCompanyProfileMap&v=weekly`;
      script.async = true;
      script.defer = true;
      return script;
    },
  update_company_profile(){
     if (!this.validate_form()) {
          return;
        }
      Swal.fire({
          title: 'Updating...',
          text: 'Please wait while we update the company profile.',
          allowOutsideClick: false,
          didOpen: () => {
              Swal.showLoading();
          }
      });

      this.is_loading = true;
      const form_data = new FormData();
      form_data.append('base_profile_id',this.base_profile_id);
      form_data.append('company_name', this.company_name);
      form_data.append('type_of_organization_id', this.selected_type_of_organization);
      this.description = this.$refs.quill_company_editor_ref.getHTML()
      form_data.append('description', this.description);
      form_data.append('email', this.email);
      form_data.append('tell_number', this.tell_number);
      form_data.append('location', this.location);
        form_data.append("street_address", this.address_list.street_address);
        form_data.append("suburb", this.address_list.suburb);
        form_data.append("town", this.address_list.town);
        form_data.append("province", this.address_list.province);
        form_data.append("postal_code", this.address_list.postal_code);
        
      $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/update_user_company/`,
          type: 'POST',
          headers: {
              Authorization: `Token ${get_token()}`,
          },
          data: form_data,
          processData: false,
          contentType: false,
          success: (response) => {
              if (response.status === 'success') {
                this.$emit('profile_updated');

                  Swal.fire({
                      title: 'Success',
                      text: 'Company Profile Updated Successfully',
                      icon: 'success',
                      timer: 1000,
                      showConfirmButton: false,
                      position: 'bottom-end',
                      toast: true
                  }).then(() => {
                    $('#company_profile_modal').modal('hide');
                  });
              }
          },
          error: (error) => {
              console.error('Error:', error);
              Swal.fire({
                  title: 'Error',
                  text: 'An error occurred while updating the profile',
                  icon: 'error',
                  position: 'bottom-end',
                  showConfirmButton: false,
                  timer: 3000,
                  toast: true
              });
          },
          complete: () => {
            this.clear_company_form()
              this.is_loading = false;
          },
      });
  },
    toggle_sidebars() {
      if (this.is_events_page) {
        this.toggle_event_sidebar(); // Toggle the event sidebar
      } else {
        this.toggle_home_sidebar(); // Toggle the main sidebar
      }
    },
    toggle_event_sidebar() {
      this.is_event_sidebar_open = !this.is_event_sidebar_open; // Toggle event sidebar
    },
    toggle_home_sidebar() {
      this.is_sidebar_open = !this.is_sidebar_open; // Toggle main sidebar
    },
    get_user_id() {
      const user_id = localStorage.getItem('user_id') || '';
      return user_id;
  },
  type_of_profile_id(name) {
    const profile_type = this.type_of_profile.find(type => type.name.toLowerCase() === name.toLowerCase());
    return profile_type ? profile_type.id : null;
  },
  matches_profile_type(profile, name) {
    return profile_matches_type(profile, name, this.type_of_profile_id(name));
  },
  get_session_personal_profile() {
    if (!this.user_details?.user_id) return null;

    return {
      id: this.user_details.user_id,
      is_session_personal_profile: true,
      profile_name: [this.user_details.first_name, this.user_details.last_name].filter(Boolean).join(' '),
      profile_type: 'personal',
      user: {
        id: this.user_details.user_id,
        first_name: this.user_details.first_name,
        last_name: this.user_details.last_name,
        email: this.user_details.email,
      },
    };
  },
  get_user_base_profiles_payload() {
    const user_id = this.user_id || this.user_details?.user_id;
    return user_id ? { user_id } : {};
  },
  with_session_personal_profile(profiles = []) {
    const profile_list = Array.isArray(profiles) ? profiles : [];
    const has_personal_profile = profile_list.some((profile) => this.matches_profile_type(profile, 'personal'));
    const session_personal_profile = this.get_session_personal_profile();

    return has_personal_profile || !session_personal_profile
      ? profile_list
      : [session_personal_profile, ...profile_list];
  },
  get_switch_profile_id(profile = {}) {
    return profile?.base_profile?.id ||
      profile?.id ||
      '';
  },
  find_base_profile_by_switch_id(profile_id) {
    return this.base_profiles.find((profile) => {
      return String(this.get_switch_profile_id(profile)) === String(profile_id) ||
        String(profile.id) === String(profile_id);
    });
  },
  get_selected_switch_profile(profile_or_id) {
    return typeof profile_or_id === 'object'
      ? profile_or_id
      : this.find_base_profile_by_switch_id(profile_or_id);
  },
  get_switch_profile_id_from_value(profile_or_id, selected_profile) {
    return typeof profile_or_id === 'object'
      ? this.get_switch_profile_id(selected_profile)
      : profile_or_id;
  },
  get_current_profile_switch_id() {
    return this.current_profile?.company?.base_profile?.id ||
      this.current_profile?.base_profile?.id ||
      this.current_profile?.id ||
      '';
  },
  is_base_profile_active(profile = {}) {
    if (profile?.is_active) return true;

    const current_profile_id = this.get_current_profile_switch_id();
    const profile_id = this.get_switch_profile_id(profile);
    if (String(current_profile_id) === String(profile_id)) {
      return true;
    }

    return false;
  },
  get_profile_type_for_redirect(profile = {}) {
    if (this.matches_profile_type(profile, 'business')) return 'business';
    if (this.matches_profile_type(profile, 'personal')) return 'personal';

    return profile?.profile_type;
  },
  get_profile_for_redirect(profile = {}) {
    return Object.assign({}, profile, {
      profile_type: this.get_profile_type_for_redirect(profile),
    });
  },
    logout_user() {
      Swal.fire({
        title: 'Are you sure?',
        text: "Are you sure you want to logout?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, log out!',
        position: 'bottom-end',
        toast: true
      }).then(async (result) => {
        if (result.isConfirmed) {
          clear_token();
          if (client_domain.includes('dwypd')){
            window.location = `/knowledgehub`;
          }else{
          window.location = `/sign_in_finale`;
          }
        }
      });
    },
    toggle_icons() {
      this.show_icons = !this.show_icons;
    },

    get_all_profile() {
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/retrieve_users/`,
        type: 'GET',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json',
        },
        data: append_active_organization_id({user_id: this.user_id}),
        success: (data) => {
          this.users = data.data.users_list;
        }
      }
      )},
    toggle_search() {
      this.show_search = !this.show_search;
    },
    clear_search_dropdown() {
      this.search_query = '';
      this.filtered_recent = [];
      this.filtered_profiles = null;
      this.show_search = false;
      $(document).off("click.recent");
    },
    update_first_time_login_status() {
          $.ajax({
              type: 'POST',
              url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/update_first_time_login/`,
              contentType: 'application/json',
              headers: {
                  'Authorization': `Token ${get_token()}`,
              },

              success: (response) => {
                  var response_data = response.data;
                  set_user_details(response_data.user_details);
              }
          });
      },
      apply_history(history) {
    this.search_query = history;
    this.filter_profiles(); // re-run search
  },
  show_recent() {
  this.filtered_recent = this.search_history ? [...this.search_history] : [];

  if (!this.filtered_profiles) this.filtered_profiles = [];

  $(document).off("click.recent").on("click.recent", (e) => {
    if (!$(e.target).closest(".topbarnav, .search-bar").length) {
      this.show_search = false;
      this.filtered_recent = [];
      this.filtered_profiles = null;
      $(document).off("click.recent");
    }
  });
},
display_tags(tags) {
    if (!tags) return [];
    if (this.search_query) {
      const matched = tags.filter(tag =>
        tag.name.toLowerCase().includes(this.search_query.toLowerCase())
      );
      if (matched.length) {
        // return only matched tag names
        return matched.map(t => t.name);
      }
    }
    // default: return first 2 tag names
    return tags.slice(0, 2).map(t => t.name);
  },
  get_search_history() {
    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/get_search_history/`,
      type: 'GET',
      headers: {
        Authorization: `Token ${get_token()}`
      },
       success: (response) => {
      if (response.status === 'success') {
        if (response.data && Array.isArray(response.data)) {
          this.search_history = response.data.slice(0, 5);
        } else {
          this.search_history = []
        }
      }
    },
      error: (err) => {
        console.error('Failed to fetch search history', err);
      }
    });
  },
  create_search_history() {
    
    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/create_search_history/`,
      type: 'POST',
      headers: {
        Authorization: `Token ${get_token()}`,
        'Content-Type': 'application/json'
      },
      data: JSON.stringify({
        query: this.search_query,
        user_id: this.user_details.user_id
      }),
      success: (response) => {
        if (response.status === 'success') {
          if (!this.search_history.includes(this.search_query)) {
            this.search_history.unshift(this.search_query);
            if (this.search_history.length > 10) this.search_history.pop();
          }
        }
      },
      error: (err) => {
        console.error('Failed to save search history', err);
      }
    });
  },

   remove_history(history_id) {

    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/delete_search_history/`,
      type: 'DELETE',
      headers: {
        Authorization: `Token ${get_token()}`
      },
      data:{
        history_id:history_id
      },
      success: (response) => {
        if (response.status === 'success') {
          this.filtered_recent = this.filtered_recent.filter(item => item.id !== history_id);
        }
      }
    });
  },
    filter_profiles() {
    // Clear any previous timeout so only the LAST keystroke triggers the request
    clearTimeout(this.search_timeout);

    if (this.search_query && this.search_query.length >= 3) {
        this.is_loading = true;
        this.search_timeout = setTimeout(() => {
            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/global_search_api/`,
                type: 'POST',
                headers: {
                    Authorization: `Token ${get_token()}`,
                    'Content-Type': 'application/json'
                },
                data: JSON.stringify({
                    query: this.search_query
                }),
                success: (response) => {
                    if (response.status === 'success') {
                        const data = response.data || {};
                        if (Array.isArray(data.portals)) {
                            data.portals = data.portals.filter(
                                portal => portal.name?.toLowerCase() !== 'default portal'
                            );
                        }
                      this.filtered_profiles = response.data;
                        this.filtered_recent = this.search_history.filter(h =>
                            h.query.toLowerCase().includes(this.search_query.toLowerCase())
                        );
                    }
                },
                complete: () => {
                    this.is_loading = false;
                }
            });
        }, 3000); // <--- 3 seconds
    } else {
        this.filtered_profiles = [];
        this.filtered_recent = this.search_history;
    }
},



 view_profile(profile) {
      view_profile_helper(this.$router, this.get_profile_for_redirect(profile));
    },

      view_report(report) {
        this.create_search_history()

        window.location = `/home?report_id=${report.id}`;

  },


  view_product_details(product){
    this.create_search_history();
      view_profile_product(this.$router, product);
    },

  toggle_expand(section) {
    this.expanded_section =
      this.expanded_section === section ? null : section;
  },
  displayed_description(report) {
  if (!report.description) return '';

  // 1. Remove HTML tags
  let text = report.description.replace(/<[^>]*>/g, '');

  // 2. Collapse multiple spaces/newlines into a single space
  text = text.replace(/\s+/g, ' ').trim();

  // 3. Take at least the first 10 characters
  if (text.length <= 30) {
    return text;
  } else {
    return text.substring(0, 30) + '...';
  }
},

      control_switching_profile(base_profile){
        if (base_profile?.is_session_personal_profile) {
          this.view_profile(base_profile);
          return;
        }

        if(client_domain.includes('cbo')){
          this.view_profile_nav(base_profile)
        }
        else{

          this.switch_profile(base_profile);
        }
      },

      view_profile_nav(base_profile){
        this.view_profile(base_profile);
      },
      view_portal(portal){
        this.create_search_history()
          if (portal?.portal_type?.name === 'incident') {
            this.$router.push({ name: 'view_incidents', params: { portal_id: portal.portal_id, portal_name:portal.name,} });
          }
          else if(portal?.portal_type?.name === 'publishing'){
             this.$router.push({ name: 'publish_portal', params: { portal_id: portal.id, portal_name:portal.name,} });
          }
           else
            this.$router.push({ name: 'view_portal', params: { portal_id: portal.id, portal_name: portal.name, is_public: portal.is_public, is_visible: portal.is_visible } });

      },

      initialize_map() {
      const input = this.get_company_address_input();
      if (!this.can_initialize_company_map(input)) return;
      if (this.map_autocomplete_is_current(input)) return;
      if (this.uses_place_autocomplete_element(input)) return;

      this.create_company_address_autocomplete(input);
    },
    get_company_address_input() {
      return document.getElementById('company_street_address');
    },
    can_initialize_company_map(input) {
      return Boolean(input && window.google?.maps?.places);
    },
    map_autocomplete_is_current(input) {
      return this.company_address_autocomplete && this.company_address_input === input;
    },
    uses_place_autocomplete_element(input) {
      if (!window.google.maps.places.PlaceAutocompleteElement) return false;
      this.company_address_input = input;
      return true;
    },
    create_company_address_autocomplete(input) {
      this.company_address_autocomplete = new window.google.maps.places.Autocomplete(input, {
        componentRestrictions: { country: 'za' },
        fields: ['address_components', 'formatted_address', 'geometry', 'name'],
      });
      this.company_address_input = input;
      this.company_address_autocomplete.addListener('place_changed', () => {
        this.handle_company_place_changed(input);
      });
    },
    handle_company_place_changed(input) {
      const place = this.company_address_autocomplete.getPlace();
      if (!place) return;

      this.location = place.formatted_address || input.value;
      this.set_company_address_from_place(place);
      this.$emit('location_selected', this.location);
    },
    get_address_component(place, type) {
      return place.address_components?.find(component => component.types.includes(type))?.long_name || '';
    },
    get_first_address_value(...values) {
      return values.find(Boolean) || '';
    },
    set_company_address_from_place(place) {
      const street_number = this.get_address_component(place, 'street_number');
      const route = this.get_address_component(place, 'route');
      const street_address = this.get_first_address_value(
        [street_number, route].filter(Boolean).join(' '),
        place.formatted_address,
        this.location
      );

      this.address_list.street_address = street_address;
      this.location = this.get_first_address_value(place.formatted_address, street_address, this.location);
      this.address_list.suburb = this.get_first_address_value(
        this.get_address_component(place, 'sublocality'),
        this.get_address_component(place, 'sublocality_level_1'),
        this.get_address_component(place, 'neighborhood')
      );
      this.address_list.town = this.get_first_address_value(
        this.get_address_component(place, 'locality'),
        this.get_address_component(place, 'administrative_area_level_2')
      );
      this.address_list.province = this.get_address_component(place, 'administrative_area_level_1');
      this.address_list.postal_code = this.get_address_component(place, 'postal_code');
      this.address_list.country = this.get_address_component(place, 'country');
      this.latitude = place.geometry?.location?.lat?.() ?? null;
      this.longitude = place.geometry?.location?.lng?.() ?? null;
    },
    my_learning_view() {
      this.get_learning_program_name();
  },
  get_learning_program_name() {
    const learning_programs = [
      { domain: '919', name: '919 learning' },
      { domain: 'chamber', name: 'ICT Chamber learning' },
      { domain: 'community', name: 'Funax Community learning' },
      { domain: 'workbook', name: 'IC workbook learning' },
    ];
    const program = learning_programs.find((item) => client_domain.includes(item.domain));
    return program?.name || 'workstreams learning';
  },
  go_to_view_membership(){
    this.$router.push('/view_membership');
  },

    open_maintenance() {
      if (!this.token_exists) {
          this.$router.push('/sign_in_finale');
          return;
      }
      this.$router.push('/incident_reporting');
    },
    fetch_profiles() {

      $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_profiles/`,
          type: 'POST',
          headers: {
              Authorization: `Token ${get_token()}`,
              'Content-Type': 'application/json',
          },
          data: JSON.stringify(this.get_user_base_profiles_payload()),
          success: (response) => {
              if (response.status === 'success' && response.data.profiles) {
                  this.base_profiles = this.with_session_personal_profile(response.data.profiles);
                  this.$emit('active_profile', this.active_base_profile);
              }
          },
      });
  },
  clear_personal_data() {
      this.email = '';
      this.phone_number = '';
  },

  switch_profile(profile_or_id,is_loading = true) {
    const selected_profile = this.get_selected_switch_profile(profile_or_id);
    const profile_id = this.get_switch_profile_id_from_value(profile_or_id, selected_profile);

  if (!profile_id) {
    if (selected_profile) this.view_profile(selected_profile);
    return;
  }

    this.is_loading = is_loading;
    this.profile_switch_loading = is_loading;
    let switch_succeeded = false;

    $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/switch_profile/`,
        method: 'POST',
        headers: {
            Authorization: `Token ${get_token()}`,
            'Content-Type': 'application/json',
          },
          data: JSON.stringify({ profile_id: profile_id ,user_id:this.user_id}),
          success: (response) => {
            if (response.status === 'success') {
              switch_succeeded = true;

              this.get_active_profile();

              this.base_profiles.forEach(profile => {
                profile.is_active = String(this.get_switch_profile_id(profile)) === String(profile_id);
              });
            }
          },
          error: (xhr, status, error) => {
            console.error("Error switching profile:", error);
          },
          complete: () => {
            // Delay the loading state completion by 3 seconds
            setTimeout(() => {
              this.is_loading = false;
              this.profile_switch_loading = false;
              if (switch_succeeded && selected_profile) {
                this.view_profile(selected_profile);
              }
            }, 2000);
          },
    });
  },

  get_active_profile() {
    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_active_profile/`,
      type: "GET",
      headers: {
        Authorization: `Token ${get_token()}`,
        "Content-Type": "application/json",
      },
      success: (response) => {
        if (response.status === "success") {
          this.current_profile = this.get_active_profile_response_data(response.data);
          localStorage.setItem('active_profile', JSON.stringify(this.current_profile || {}));
          this.load_active_profile_branding();
          this.$emit('active-profile-loaded', this.current_profile)
          const profile_type_name = this.get_profile_type_name(this.current_profile);
          if (profile_type_name === 'business' && this.current_profile?.is_active) {
            this.clear_personal_data();
            this.is_business_profile = true;
          } else {
            this.receive_emails = this.current_profile?.user?.receive_emails;
            this.receive_notifications = this.current_profile?.user?.receive_notifications;
            this.is_business_profile = false;
            this.company_data = null;
          }

        }
      },
      error: (xhr, status, error) => {
        console.error("Error fetching active profile:", error);
      },
    });
  },
  get_active_profile_response_data(profile) {
    if (!this.should_use_stored_organization_profile(profile)) {
      return profile;
    }

    return this.get_matching_stored_profile() || profile;
  },
  should_use_stored_organization_profile(profile) {
    return !this.is_personal_profile_response(profile)
      && !this.get_profile_organization_id(profile)
      && Boolean(get_active_organization_id());
  },
  get_matching_stored_profile() {
    const stored_profile = this.get_stored_active_profile();
    const stored_organization_id = get_active_organization_id();
    const stored_profile_organization_id = this.get_profile_organization_id(stored_profile);
    return String(stored_profile_organization_id || '') === String(stored_organization_id)
      ? stored_profile
      : null;
  },
  get_stored_active_profile() {
    try {
      return JSON.parse(localStorage.getItem('active_profile') || '{}');
    } catch {
      return {};
    }
  },
  is_personal_profile_response(profile) {
    if (this.get_profile_type_name(profile) === 'personal') return true;
    return this.has_personal_profile_fields(profile) && !this.get_profile_organization_id(profile);
  },
  has_personal_profile_fields(profile) {
    return Boolean(profile?.user || profile?.first_name || profile?.last_name || profile?.email);
  },
  get_profile_type_name(profile) {
    return profile
      ? this.get_profile_type_name_from_profile(profile)
      : '';
  },
  get_profile_type_name_from_profile(profile) {
    return this.get_profile_type_value_name(profile.profile_type)
      || this.get_profile_type_fallback_name(profile);
  },
  get_profile_type_value_name(profile_type) {
    return typeof profile_type === 'string'
      ? profile_type.toLowerCase()
      : this.get_profile_type_object_name(profile_type);
  },
  get_profile_type_object_name(profile_type) {
    return String(profile_type?.profile_type || profile_type?.name || '').toLowerCase();
  },
  get_profile_type_fallback_name(profile) {
    return this.has_business_profile_data(profile) ? 'business' : 'personal';
  },
  has_business_profile_data(profile) {
    return Boolean(profile?.company || profile?.company_id);
  },

  toggle_show_all() {
    this.show_all = !this.show_all;
  },
  fetch_type_of_profile() {

    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_type_of_profile/`,
      type: 'GET',
      headers: {
        Authorization: `Token ${get_token()}`,
        'Content-Type': 'application/json',
      },
      success: (response) => {
        if (response.status === 'success') {
          this.type_of_profile = response.data.type_of_profile_data;
          // this.show_questions();
        }
      },

    });
  },
  go_to_unified_search() {
    if (this.search_query && this.search_query.length > 0) {
      this.show_search = false;
      this.filtered_profiles = [];
      this.$router.push({ name: 'unified_search', query: { q: this.search_query } })
      }
    },


//   show_questions() {
//   const business_profile = this.type_of_profile.find(
//     (profile) => profile.name?.toLowerCase() === 'business'
//   );

//   if (!business_profile || !business_profile.id) {
//     console.error("Business profile not found or invalid.");
//     return;
//   }

//   const payload = {
//     filter_values: {
//       profile_type_id: business_profile.id,
//     },
//   };

//   $.ajax({
//     url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/filter_assigned_profile_questions/`,
//     type: "POST",
//     headers: {
//       Authorization: `Token ${get_token()}`,
//       "Content-Type": "application/json",
//     },
//     data: JSON.stringify(payload),
//     success: (response) => {
//       this.profile_questions =response.data
//       this.$emit('questions_fetched', this.profile_questions)
//     },
//     error: (xhr, status, err) => {
//       console.error("Failed to fetch questions:", err);
//     }
//   });
// },


update_answer(question_id, value) {
  const question_section = this.profile_questions
    ?.flatMap(f => f?.form?.form_sections || [])
    ?.flatMap(s => s?.section?.question_sections || [])
    ?.find(qs => qs?.question?.id === question_id);

  if (question_section) {
    question_section.answer = value;
  }
},

      toggle_checkbox_answer(question_id, option, is_checked) {
        const question_section = this.profile_questions
          ?.flatMap(f => f?.form?.form_sections || [])
          ?.flatMap(s => s?.section?.question_sections || [])
          ?.find(qs => qs?.question?.id === question_id);

        if (!question_section) return;
        this.ensure_checkbox_answer_list(question_section);
        this.update_checkbox_answer(question_section, option, is_checked);
      },
      ensure_checkbox_answer_list(question_section) {
        if (Array.isArray(question_section.answer)) return;
        question_section.answer = [];
      },
      update_checkbox_answer(question_section, option, is_checked) {
        if (!is_checked) {
          question_section.answer = question_section.answer.filter(o => o !== option);
          return;
        }

        if (!question_section.answer.includes(option)) {
          question_section.answer.push(option);
        }
      },
      validate_form() {
        this.errors = {};
        this.validate_company_name();
        this.validate_type_of_organization();
        this.validate_company_email();

        return Object.keys(this.errors).length === 0;
      },
      validate_company_name() {
        if (this.company_name) return;
        this.errors.company_name = 'Company name is required.';
      },
      validate_type_of_organization() {
        if (this.selected_type_of_organization) return;
        this.errors.type_of_organization_id = 'Type of organisation is required.';
      },
      validate_company_email() {
        if (!this.email || /\S+@\S+\.\S+/.test(this.email)) return;
        this.errors.email = 'Invalid email format.';
      },

      reset_company_form() {
        this.company_name = ''
        this.selected_type_of_organization = ''
        this.description = ''
        this.email = ''
        this.tell_number = ''
        this.location = ''
        this.address_list = this.get_empty_company_address()
        this.latitude = null
        this.longitude = null

        // clear quill editor
        if (this.$refs.quill_company_editor_ref) {
          this.$refs.quill_company_editor_ref.setHTML('')
        }
      },

      save_company_profile() {
        if (!this.validate_form()) {
          return;
        }
        this.show_company_profile_submit_loader();
        this.is_loading = true;

        $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/create_company_profile/`,
            type: 'POST',
            headers: {
                Authorization: `Token ${get_token()}`,
            },
            data: this.get_company_profile_form_data(),
            processData: false,
            contentType: false,
            success: (response) => {
                this.handle_company_profile_created(response);
            },
            error: (error) => {
                this.handle_company_profile_create_error(error);
            },
            complete: () => {
              this.fetch_profiles();
                this.is_loading = false;
            },
        });
    },
    show_company_profile_submit_loader() {
        Swal.fire({
            title: 'Submitting...',
            text: 'Please wait while we create the company profile.',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });
    },
    get_company_profile_form_data() {
        const business_profile = this.type_of_profile.find(
          (profile) => profile.name.toUpperCase() === 'BUSINESS'
        );

        const form_data = new FormData();
        form_data.append('company_name', this.company_name);
        form_data.append('type_of_organization_id', this.selected_type_of_organization);
        this.description = this.$refs.quill_company_editor_ref.getHTML()
        form_data.append('description', this.description);
        form_data.append('email', this.email|| '');
        form_data.append('tell_number', this.tell_number|| '');
        form_data.append("street_address", this.address_list.street_address);
        form_data.append("suburb", this.address_list.suburb);
        form_data.append("town", this.address_list.town);
        form_data.append("province", this.address_list.province);
        form_data.append("postal_code", this.address_list.postal_code);
        form_data.append("country", this.address_list.country);
        form_data.append('profile_type_id', business_profile.id);
        const organization_id = this.get_company_profile_parent_organization_id();
        if (organization_id) {
          form_data.append('organization_id', organization_id);
        }

        return form_data;
    },
    handle_company_profile_created(response) {
        if (response.status === 'success') {
            this.show_company_profile_created_message();
        }
        this.switch_profile(response?.data?.company_data?.base_profile?.id,false);
    },
    show_company_profile_created_message() {
        Swal.fire({
            title: 'Success',
            text: 'Company Profile Created Successfully',
            icon: 'success',
            timer: 2000,
            showConfirmButton: false,
            position: 'bottom-end',
            toast: true
        }).then(() => {
            if(this.user_details.first_time_login==='true'){
              this.update_first_time_login_status()
            }
          this.$emit('business_profile_created');
          $('#company_profile_modal').modal('hide');
          this.reset_company_form();
        });
    },
    handle_company_profile_create_error(error) {
        console.error('Error:', error);
        Swal.fire({
            title: 'Error',
            text: 'An error occurred while creating the profile',
            icon: 'error',
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000,
            toast: true
        });
    },
    get_company_profile_parent_organization_id() {
      if (!this.is_enabled_feature(this.client_features?.show_organisation)) {
        return '';
      }

      return this.user_details?.organization_id
        || get_active_organization_id()
        || '';
    },
    fetch_type_of_organization() {

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/get_type_of_organization/`,
        type: 'GET',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json',
        },
        success: (response) => {
          if (response.status === 'success') {
            this.type_of_organization = response.data.type_of_organization_data;
          }
        },
      });
    },
    clear_company_form() {
      this.is_edit_mode = false;
      this.company_name = '';
      this.selected_type_of_organization = '';
      this.description = '';
      this.email = '';
      this.tell_number = '';
      this.location = '';
      this.address_list = this.get_empty_company_address();
      this.latitude = null;
      this.longitude = null;
      this.base_profile_id = null;
      this.errors = {};
      // Clear Quill editor if ref exists
      this.$nextTick(() => {
        if (this.$refs.quill_company_editor_ref) {
          if (typeof this.$refs.quill_company_editor_ref.setHTML === 'function') {
            this.$refs.quill_company_editor_ref.setHTML('');
          } else if (this.$refs.quill_company_editor_ref.quill) {
            this.$refs.quill_company_editor_ref.quill.root.innerHTML = '';
          }
        }
      });
    },


    update_user_settings() {
      this.is_loading = true;

      const payload = {
        receive_emails: !!this.receive_emails,
        receive_notifications: !!this.receive_notifications,
      };

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/update_user_settings/`,
        type: 'POST',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json',
        },
        data: JSON.stringify(payload),
        success: () => {
          Swal.fire({
            title: 'Success',
            text: 'Settings updated successfully',
            icon: 'success',
            timer: 1000,
            showConfirmButton: false,
            position: 'bottom-end',
            toast: true
          }).then(() => {
            $('#notificationSettingsModal').modal('hide');
          });
        },
        error: (xhr) => {
          console.error("Update User Settings Error:", xhr.responseText);
          Swal.fire({
            title: 'Error',
            text: 'Failed to update settings. Please try again.',
            icon: 'error',
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000,
            toast: true
          });
        },
        complete: () => {
          this.is_loading = false;
        },
      });
    },
    confirm_deactivation() {
      Swal.fire({
        title: 'Are you sure?',
        text: "You are about to deactivate your account. You can reactivate anytime by logging back in.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, deactivate it!',
        position: 'bottom-end',
        toast: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.deactivate_account();
        }
      });
    },
    deactivate_account() {
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/deactivate_account/`,
        type: 'POST',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json'
        },
        success: (response) => {
          if (response.status === 'success') {
            Swal.fire({
              title: 'Deactivated!',
              text: response.message || 'Your account has been deactivated.',
              icon: 'success',
              timer: 2000,
              showConfirmButton: false,
              position: 'bottom-end',
              toast: true
            }).then(() => {
              clear_token();
              window.location = '/sign_in_finale' // kick user out after deactivation
            });
          }
        },
        error: (error) => {
          Swal.fire({
            title: 'Error!',
            text: error.responseJSON?.message || 'Something went wrong',
            icon: 'error',
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000,
            toast: true
          });
        }
      });
    },
    confirm_account_deletion() {
      Swal.fire({
        title: 'Delete account permanently?',
        text: 'This will permanently delete your account and cannot be undone.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, delete it!',
        position: 'bottom-end',
        toast: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.delete_account();
        }
      });
    },
    delete_account() {
      this.is_loading = true;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/delete_account/`,
        type: 'DELETE',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json'
        },
        success: (response) => {
          this.handle_delete_account_response(response);
        },
        error: (error) => {
          this.show_delete_account_error(error.responseJSON?.message);
        },
        complete: () => {
          this.is_loading = false;
        }
      });
    },
    handle_delete_account_response(response) {
      if (response.status === 'success') {
        this.show_delete_account_success(response.message);
        return;
      }

      this.show_delete_account_error(response.message);
    },
    show_delete_account_success(message) {
      Swal.fire({
        title: 'Account deleted',
        text: message || 'Your account has been deleted.',
        icon: 'success',
        timer: 2000,
        showConfirmButton: false,
        position: 'bottom-end',
        toast: true
      }).then(() => {
        clear_token();
        window.location = '/sign_in_finale';
      });
    },
    show_delete_account_error(message) {
      Swal.fire({
        title: 'Error!',
        text: message || 'Could not delete your account. Please try again.',
        icon: 'error',
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 3000,
        toast: true
      });
    }
  }
};


